export const complexSelectorState = state => (  state.complexSelectors  );